export default __webpack_public_path__ + "static/media/resume3.47856116.pdf";